import React from 'react';
import './BusinessInfo.css';

const BusinessInfo = () => {
	return (
		<div className="business-container">
			<div className="business-content">
				<h1>사업자정보확인</h1>
				
				<div className="business-card">
					<div className="business-header">
						<h2>wearToday</h2>
						<span className="business-badge">통신판매업</span>
					</div>

					<div className="business-info-grid">
						<div className="info-row">
							<span className="info-label">상호명</span>
							<span className="info-value">wearToday</span>
						</div>

						<div className="info-row">
							<span className="info-label">대표자</span>
							<span className="info-value">김대표</span>
						</div>

						<div className="info-row">
							<span className="info-label">사업자등록번호</span>
							<span className="info-value">165-17-02491</span>
						</div>

						<div className="info-row">
							<span className="info-label">통신판매업신고번호</span>
							<span className="info-value">2025-수원장안-0904</span>
						</div>

						<div className="info-row">
							<span className="info-label">사업장 소재지</span>
							<span className="info-value">경기도 수원시 장안구</span>
						</div>

						<div className="info-row">
							<span className="info-label">대표 전화</span>
							<span className="info-value">카카오톡 상담 (평일 10:00-18:00)</span>
						</div>

						<div className="info-row">
							<span className="info-label">이메일</span>
							<span className="info-value">cozip99@naver.com</span>
						</div>

						<div className="info-row">
							<span className="info-label">호스팅 서비스</span>
							<span className="info-value">자체 운영</span>
						</div>

						<div className="info-row full-width">
							<span className="info-label">사업 내용</span>
							<span className="info-value">해외 구매대행 서비스 (의류, 패션 잡화)</span>
						</div>
					</div>
				</div>

				<div className="business-notice">
					<h3>📌 구매대행 서비스 안내</h3>
					<ul>
						<li>wearToday는 해외 상품 구매대행 전문 업체입니다.</li>
						<li>상품 주문 후 해외에서 직접 구매하여 국내로 배송합니다.</li>
						<li>배송 기간은 현지 사정에 따라 7~14일 소요됩니다.</li>
						<li>관세법에 따라 일정 금액 초과 시 관세가 부과될 수 있습니다.</li>
					</ul>
				</div>

				<div className="business-links">
					<a 
						href="https://www.ftc.go.kr/bizCommPop.do?wrkr_no=1651702491" 
						target="_blank" 
						rel="noopener noreferrer"
						className="btn-verify"
					>
						🔍 사업자정보 공정거래위원회 확인
					</a>
					
					<a 
						href="https://open.kakao.com/o/sJ2m9h3h" 
						target="_blank" 
						rel="noopener noreferrer"
						className="btn-kakao"
					>
						💬 카카오톡 상담하기
					</a>
				</div>

				<div className="business-footer">
					<button onClick={() => window.history.back()} className="btn-back">
						← 돌아가기
					</button>
				</div>
			</div>
		</div>
	);
};

export default BusinessInfo;